// removed by extract-text-webpack-plugin
module.exports = {"dialogBox":"_1MgHSHGOwHcb3bhm2-ANw2","dialogContainer":"_3x9JeCPKc8olVDP8gFQ5ZM","blueBar":"yVbc0uFP5hS6PokvbDeKl","wrapper":"_2mAsuedXw9NCmNcCP_vTiX"};


//////////////////
// WEBPACK FOOTER
// ./src/views/ManageLogs/style.css
// module id = 1101
// module chunks = 0